import actionTypes from '../actionTypes'

const updateProjects = projects => {
  return {
    type: actionTypes.SET_PROJECTS,
    payload: projects,
  }
}

const updateIsFetchProjects = isFetchProjects => {
  return {
    type: actionTypes.SET_IS_FETCH_PROJECTS,
    payload: isFetchProjects,
  }
}

const updateSelectedProject = project => {
  return {
    type: actionTypes.SET_SELECTED_PROJECT,
    payload: project,
  }
}

const updateProjectSecrets = secrets => {
  return {
    type: actionTypes.SET_PROJECT_SECRETS,
    payload: secrets,
  }
}

const updateProjectEnvironments = environments => {
  return {
    type: actionTypes.SET_PROJECT_ENVIRONMENTS,
    payload: environments,
  }
}

const updateIsFetchProjectSecrets = isFetchProjectSecrets => {
  return {
    type: actionTypes.SET_IS_FETCH_PROJECT_SECRETS,
    payload: isFetchProjectSecrets,
  }
}

const updateIsFetchProjectEnvironments = isFetchProjectEnvironments => {
  return {
    type: actionTypes.SET_IS_FETCH_PROJECT_ENVIRONMENTS,
    payload: isFetchProjectEnvironments,
  }
}

export default {
  updateProjects,
  updateIsFetchProjects,
  updateSelectedProject,
  updateProjectSecrets,
  updateProjectEnvironments,
  updateIsFetchProjectSecrets,
  updateIsFetchProjectEnvironments
}